import './index_web.css';
import { View, Text } from '../../../component';
import I18n from '../../../utilities/locale';
import { getPlayerName, isMatchInScheduled } from '../../../utilities/helper';
import ChooseCapPlayerRow from '../../component/choose_cap_player_row';
import Constants from '../../../constants';
import DefaultContainer from '../../../container/default_container';
import { CounterWrapper } from '../../../component/header_with_timer';
import GuideTour from '../../../component/guide_tour';
import { useSelector } from 'react-redux';
import useTheme from '../../../utilities/hooks/theme';
const PlayerType = (data: any) => {
  const { shortName = '' } = data;
  return shortName.length > 0 ? `${getPlayerName(shortName)}` : '-';
};

const ChooseCaptainWeb = ({
  teamNumber,
  matchItem,
  gameType,
  selectedPlayer,
  selectedCaptain,
  selectedViceCaptain,
  teamA,
  teamB,
  captain,
  // PlayerType: PlayerType,
  viceCaptain,
  captainData,
  viceCaptainData,
  onPressContinue,
  onCalledDeadline
}: any) => {
  const { teamName = '' } = useSelector((state: any) => state.user);
  const { FantasyTheme: theme } = useTheme();

  const renderHeader = (matchItem: any, onCalledDeadline: any, gameType: any) => {
    const { status: matchStatus, verified, gameState = 0, matchDelayed = false } = matchItem;

    const isMatchScheduled = isMatchInScheduled({
      matchStatus,
      gameState,
      matchDelayed,
      gameType
    });
    const timerIconDimension = '20px';

    return (
      <>
        <div className="choose_captain_vice_captain_cricket">
          <View className="fantasy_cricket_header_timer_wrapper" style={{ paddingLeft: '80px' }}>
            {isMatchScheduled && (
              <View className="header-with-timer-icon-wrapper">
                <Constants.Svgs.Timer width={timerIconDimension} height={timerIconDimension} />
              </View>
            )}
            {
              <CounterWrapper
                onCalledDeadline={onCalledDeadline}
                matchStatus={matchStatus}
                verified={verified}
                matchItem={matchItem}
                isMatchScheduled={isMatchScheduled}
                gameType={gameType}
              />
            }
          </View>
        </div>
      </>
    );
  };
  const chooseCaptainStyle = {
    background: theme.createTeamSelectionBoxbg
  };
  const playerNameContainerStyle = {
    // border: `1px solid ${theme.createTeamTabBarBorder}`,
    background: theme.createTeamTabBarDefaultRoleTypeBG
  };
  const captainContainerStyle = {
    borderBottom: `1px solid ${theme.createTeamTabBarBorder}`,
    borderRight: `1px solid ${theme.createTeamTabBarBorder}`
    // borderLeft: `1px solid ${theme.createTeamTabBarBorder}`
  };

  const viceCaptainContainerStyle = {
    borderBottom: `1px solid ${theme.createTeamTabBarBorder}`
    // borderRight: `1px solid ${theme.createTeamTabBarBorder}`
  };

  const saveBtnStyle = {
    backgroundColor: theme.createTeamPreviewBtnLabel
  };

  const isGuideTourCompleted =
    localStorage.getItem(Constants.GuideTour['choose_captain_vice_captain_cricket'].key) === 'true';

  return (
    <DefaultContainer>
      <div className={'choose-captain-container'} id="choose_captain_vice_captain_cricket">
        {!isGuideTourCompleted && (
          <GuideTour
            steps={Constants.GuideTour['choose_captain_vice_captain_cricket'].steps}
            keyValue={Constants.GuideTour['choose_captain_vice_captain_cricket'].key}
            elementId={'choose_captain_vice_captain_cricket'}
          />
        )}
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', height: '100%' }}>
          <View className={'choose-captain-sub-container'}>
            <Text className={'choose-captain-vice-label'}>{'Select Captain & Vice Captain'}</Text>

            <View className={'choose-captain-list-container'}>
              <div className="choose_captain_vice_captain_header_title_wrapper">
                <Text
                  className={'create-team-header-team-name chooseCaptainViceCaptain__teamNumber'}>
                  {teamName ? ` ${teamName} (T${teamNumber})` : `Team No. ${teamNumber}`}
                </Text>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <Text className={'create-team-header-team-name'}>{`${teamA?.shortName}`}</Text>
                  <Text className={'create-team-header-team-name'}>vs</Text>

                  <Text className={'create-team-header-team-name'}>{`${teamB?.shortName}`}</Text>
                </div>
                {renderHeader(matchItem, onCalledDeadline, gameType)}
              </div>
              <div className="choose_captain_header_wrapper">
                <div className="choose_captain_header_container">
                  <div>Player</div>
                  <div>Role</div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: '10px',
                    width: '185px'
                  }}>
                  <View className="choose_captain_elect_text">
                    <Text>Select</Text>
                    <Text>Captain</Text>
                  </View>
                  <View className="choose_captain_elect_text">
                    <Text>Select</Text>
                    <Text>Vice-Captain</Text>
                  </View>
                </div>
              </div>
              <div className="choose_captain_vc_player_list_container">
                {selectedPlayer.map((item: any, idx: any) => (
                  <div key={idx} style={{ width: '100%' }}>
                    <ChooseCapPlayerRow
                      item={item}
                      selectedCaptain={selectedCaptain}
                      selectedViceCaptain={selectedViceCaptain}
                      teamA={teamA}
                      teamB={teamB}
                      gameType={gameType}
                    />
                  </div>
                ))}
              </div>
            </View>
          </View>
          <View className="choose-captain-right-card" style={chooseCaptainStyle}>
            <div className="choose_captain_vice_captain_title_container">
              <p>Choose Your Captain & Vice Captain</p>
            </div>
            <div className="choose_captain_vice_captain_points_name_container">
              <View className="captain_container" style={captainContainerStyle}>
                <div
                  style={{
                    borderBottom: `1px solid ${theme.createTeamTabBarBorder}`,
                    borderTop: `1px solid ${theme.createTeamTabBarBorder}`,
                    height: '50%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}>
                  <p
                    style={{
                      fontSize: '1rem',
                      fontWeight: '600',
                      color: theme.createTeamPreviewBtnLabel
                    }}>
                    Captain
                  </p>
                </div>
                <div
                  className="captain_vicecaptain_detail_container"
                  style={playerNameContainerStyle}>
                  <p className="captain__ViceCaptain__name">
                    {captain ? PlayerType(captainData) : '-'}
                  </p>
                  <p className="captain__ViceCaptain__value">2x Points</p>
                </div>
              </View>
              <View className="vice_captain_container" style={viceCaptainContainerStyle}>
                <div
                  style={{
                    borderBottom: `1px solid ${theme.createTeamTabBarBorder}`,
                    borderTop: `1px solid ${theme.createTeamTabBarBorder}`,
                    height: '50%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}>
                  <p
                    style={{
                      fontSize: '1rem',
                      fontWeight: '600',
                      color: theme.createTeamPreviewBtnLabel
                    }}>
                    Vice Captain
                  </p>
                </div>
                <div
                  className="captain_vicecaptain_detail_container"
                  style={playerNameContainerStyle}>
                  <p className="captain__ViceCaptain__name">
                    {viceCaptain ? PlayerType(viceCaptainData) : '-'}
                  </p>
                  <p className="captain__ViceCaptain__value">1.5x Points</p>
                </div>
              </View>
            </div>
            <div className="choose_captain_save_btn_container">
              <button
                className="choose_captain_save_btn"
                style={saveBtnStyle}
                onClick={onPressContinue}>
                {I18n.t('SaveTeam')}
              </button>
            </div>
          </View>
        </div>
      </div>
    </DefaultContainer>
  );
};
export default ChooseCaptainWeb;
